import { SprinklesElement } from "sprinkles-js";
import * as Turbo from "@hotwired/turbo";

export default class SmartMapElement extends SprinklesElement {
  static tagName = "smart-map";
  static refs = ["tooltip"];
  static events = {
    click: [
      { method: "handleEvent" },
      { method: "handleTooltipClick", ref: "tooltip" },
    ],
    mouseover: "handleEvent",
    mouseleave: "handleEvent",
  };

  #activeElement = null;

  handleEvent(event) {
    const target = event.target.closest("[data-legend]");
    if (!target) {
      this.activeElement = null;
    } else if (event.type === "click" && this.activeElement === target) {
      this.#navigateToPage(target);
    } else {
      this.activeElement = target;
    }
  }

  handleTooltipClick() {
    if (this.activeElement) this.#navigateToPage(this.activeElement);
  }

  set activeElement(element_or_null) {
    this.#activeElement = element_or_null;
    if (element_or_null === null) {
      this.#hideTooltip();
    } else {
      this.#showTooltip(element_or_null);
    }
  }

  get activeElement() {
    return this.#activeElement;
  }

  #showTooltip(element) {
    // Reset flip
    this.refs.tooltip.removeAttribute("data-flip-x");
    this.refs.tooltip.removeAttribute("data-flip-y");

    // Give tooltip content and position
    this.refs.tooltip.innerText = element.getAttribute("data-legend");
    const {
      y: elementY,
      x: elementX,
      width: elementWidth,
      height: elementHeight,
    } = element.getBoundingClientRect();
    this.refs.tooltip.style.setProperty("--target-width", `${elementWidth}px`);
    this.refs.tooltip.style.setProperty(
      "--target-height",
      `${elementHeight}px`,
    );
    this.refs.tooltip.style.setProperty(
      "top",
      `${elementY + window.scrollY}px`,
    );
    this.refs.tooltip.style.setProperty(
      "left",
      `${elementX + window.scrollX}px`,
    );
    this.refs.tooltip.showPopover();

    // Check if tooltip fits the viewport.
    // If the tooltip get too close to the right or bottom border, we flip this
    const {
      y: tooltipY,
      x: tooltipX,
      width,
      height,
    } = this.refs.tooltip.getBoundingClientRect();
    if (tooltipY + height > window.innerHeight * 0.9) {
      this.refs.tooltip.setAttribute("data-flip-y", true);
    }
    if (tooltipX + width > window.innerWidth * 0.9) {
      this.refs.tooltip.setAttribute("data-flip-x", true);
    }
  }

  #hideTooltip() {
    this.refs.tooltip.hidePopover();
    this.refs.tooltip.innerText = null;
  }

  #navigateToPage(element) {
    if (!element.hasAttribute("data-record-id")) return;

    const url = this.dataset.urlTemplate.replace(
      ":record_id",
      element.dataset.recordId,
    );
    Turbo.visit(url);
  }
}
